
<div class="main-content">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <div class="chat-container mat-app-background">
          <mat-toolbar color="primary" class="chat-header">
            <!-- <mat-icon class="materialicons">smart_toy</mat-icon> -->
            <img src="assets/img/Dr._Mo2-removebg.png" alt="AI Assistant" class="header-icon">

            <span class="ml-3">Dr.Mo AI Assistant</span>
            <span class="flex-grow-1"></span>
            <button mat-icon-button (click)="clearChat()" matTooltip="Clear chat">
              <mat-icon class="materialicons">clear_all</mat-icon>
            </button>
          </mat-toolbar>
        
          <div class="messages-container" #scrollContainer>
            <div class="welcome-message" *ngIf="messages.length === 0">
              <!-- <mat-icon class="welcome-icon">chat</mat-icon> -->
              <img src="assets/img/Dr._Mo_1-removebg.png" alt="AI Assistant" class="center-icon">

              <h2>Ask Dr.Mo</h2>
              <p>Ask me anything! I'm here to help.</p>
            </div>
        
            <div *ngFor="let message of messages" 
                 class="message-wrapper"
                 [ngClass]="{'user-message': message.role === 'user'}">
              <div class="message-bubble mat-elevation-z1"
                   [ngClass]="{'user-bubble': message.role === 'user'}">
                <div class="message-header">
                  <mat-icon class="message-avatar" *ngIf="message.role ==='user'" [ngClass]="{ 'materialicons': message.role === 'user' }">
                    {{message.role === 'user' ? 'person' : ''}}
                  </mat-icon>
                  <img *ngIf="message.role!='user'" src="assets/img/Dr._Mo2-removebg.png" alt="AI Assistant" class="message-mo-icon mr-2">

                  <span class="message-sender">
                    {{message.role === 'user' ? 'You' : 'Dr.Mo'}}
                  </span>
                  <span class="message-time">
                    {{message.timestamp | date:'shortTime'}}
                  </span>
                </div>
                <div class="message-content">{{message.content}}</div>
              </div>
            </div>
        
            <div *ngIf="isLoading" class="message-wrapper">
              <div class="message-bubble typing-indicator mat-elevation-z1">
                <div class="typing-dots">
                  <div class="dot"></div>
                  <div class="dot"></div>
                  <div class="dot"></div>
                </div>
              </div>
            </div>
          </div>
        
          <mat-card class="input-container">
            <form (ngSubmit)="sendMessage()" class="input-form">
              <mat-form-field appearance="outline" class="input-field">
                <mat-label>Ask Dr.Mo</mat-label>
                <textarea matInput
                       [(ngModel)]="newMessage"
                       name="message"
                       [disabled]="isLoading"
                       placeholder="Ask anything...">
                       </textarea>
              </mat-form-field>
              
              <button mat-fab
                      color="primary"
                      type="submit"
                      [disabled]="!newMessage.trim() || isLoading"
                      class="send-button">
                <mat-icon class="materialicons">send</mat-icon>
              </button>
            </form>
          </mat-card>
        </div>
        
      </div>
    </div>
  </div>

</div>
